export enum AFrameCheckStation {
  none = 0,
  chk01 = 1,
  chk02 = 2,
  both = 3,
}
